var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options)?_c('button',{staticClass:"button-box cta",on:{"click":function($event){return _vm.scrollToElement('feature-block-' + _vm.options.element_id)}}},[_c('span',[_vm._v(_vm._s(_vm.options.button_text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }